import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

type State = {
  homeId?: string;
};

type Actions = {
  setHomeId: (homeId: string) => void;
};

const initialState: State = {
  homeId: undefined,
};

export const useHomeState = create<State & Actions>()(
  immer((set) => ({
    ...initialState,
    setHomeId: (homeId: string) =>
      set((state) => {
        state.homeId = homeId;
      }),
    reset: () => {
      set(() => initialState);
    },
  }))
);
